import { Typography } from "@kyan/ui";
import Image from "next/image";

export const EmptyState: React.FC = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex flex-col items-center justify-between">
        <Typography grotesk primary size={18}>
          Select an option
        </Typography>
        <Image
          alt="Kyan"
          width={70}
          height={70}
          src="/images/common/kyan-crystal.png"
        />
      </div>
    </div>
  );
};
